import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Select } from "@outpave/ds";

interface LanguageSelectProps {
  label?: string;
}

/** The app's language, kept in this browser: the server stores no language for a person. */
const LanguageSelect: React.FC<LanguageSelectProps> = ({ label }) => {
  const { i18n, t } = useTranslation();
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    setLanguage(localStorage.getItem("language") || "en");
  }, []);

  const handleChange = (lang: string) => {
    setLanguage(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem("language", lang);
  };

  return (
    <Select
      label={label}
      aria-label={label ? undefined : t("Language")}
      clearable={false}
      options={[
        { id: "en", label: "English" },
        { id: "es", label: "Español" },
      ]}
      onChange={(value) => value && handleChange(value)}
      value={language}
    />
  );
};

export default LanguageSelect;
